import { getMod } from 'services/hooks';
import { getModComponent } from 'services/utils';

export const ModsStyles = () => {
  const FinancialFonts = getModComponent(
    getMod('financial')?.theme.FinancialFonts
  );
  const FinancialGLobalStyles = getModComponent(
    getMod('financial')?.theme.FinancialGlobalStyles
  );

  return (
    <>
      <FinancialFonts />
      <FinancialGLobalStyles />
    </>
  );
};
